// The Kalkulation rows of the costing view (docs/plans/position-grid-inline-costing.md): a
// calculation component shown under its position (`data-kind="component"`). It is no line item —
// position-tree, position-structure and position-panel all treat it as part of its position.
export function isComponentRow(row) {
  return row?.dataset.kind === "component"
}

// The line item a row stands for: a Kalkulation row's position, any other row itself.
export function positionRowId(row, rowId) {
  return isComponentRow(row) ? row.dataset.parentId : rowId
}

// The calculation component a Kalkulation row stands for (`component-<id>`).
export function componentId(row) {
  return row.dataset.rowId.replace(/^component-/, "")
}
